"use strict";
// import { BadgeControl, ButtonControl, ContentCarouselControl, DividerControl, LabelControl, PillsControl, Utilities } from "doshx_controls_web";
// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { setContentModal, setMessageModal } from "../../../reducers/slices/main";
// import { ContainerControl } from "../../../controls/container";
// import { get_auction } from "../../../api/calls/auction/get_auction";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowLeft, faEnvelope, faPhone } from "@fortawesome/pro-solid-svg-icons";
// import { faFacebook, faWhatsapp, faYoutube } from "@fortawesome/free-brands-svg-icons";
// import { lots_for_auction } from "../../../api/calls/lot/lots_for_auction";
// import { LOT_COMPLETE_DETAILS_ROUTE, LOT_DETAILS_ROUTE } from "../../../constants/routes";
// import { faCircleCalendar, faCircleLocationArrow, faFilePdf, faMoneyBill } from "@fortawesome/pro-duotone-svg-icons";
// import YouTubePlayer from "react-player/youtube";
// // import { IAuctionSliceState, setAuction } from "../../../reducers/slices/auction";
// import { ILotSliceState, setLots } from "../../../reducers/slices/lot";
// import { auction_summary } from "../../../api/calls/reporting/auction_summary";
// import { ISummarySliceState, setLotSummary, setSummary } from "../../../reducers/slices/summary";
// import { LotStatusTag } from "../../../components/tags/lot_status_tag";
// import { AuctionStatusTag } from "../../../components/tags/auction_status_tag";
// import { FLOOR_ENTITY_ID } from "../../../constants/floor";
// import { callingIcon, mailIcon, mapIcon, msgIcon, pdficon, telegramIcon, twitterIcon, whatsappIcon } from "../../../../../assets/icons";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionCompletePage = void 0;
// import soldImage from "../../../../../assets/galetti/soldImage.png";
// export const AuctionCompletePage = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const params = useParams();
//   const { auctionID } = params;
//   // const { auction } = useSelector<any, IAuctionSliceState>((state: any) => state.auctionState);
//   // const { lots } = useSelector<any, ILotSliceState>((state) => state.lotState);
//   const { summary } = useSelector<any, ISummarySliceState>((state: any) => state.summaryState);
//   const [isLoading, setIsLoading] = useState<boolean>(false);
//   // const [summary, setSummary] = useState<any>({});
//   // const [lots, setLots] = useState<any[]>([]);
//   useEffect(() => {
//     if (auctionID) {
//       setIsLoading(true);
//       auction_summary({
//         entity_id: auctionID,
//       }).then((response) => {
//         setIsLoading(false);
//         if (response.success) {
//           console.log("auction_summary response.content", response.content);
//           dispatch(setSummary(response.content));
//         } else {
//           dispatch(setMessageModal({ title: "Something went wrong!", messages: [response.message] }));
//         }
//       });
//     }
//   }, [auctionID]);
//   // useEffect(() => {
//   //   if (summary.auction?.entity_id) {
//   //     lots_for_auction({
//   //       auction_entity_id: summary.auction.entity_id,
//   //     }).then((response) => {
//   //       setIsLoading(false);
//   //       if (response.success) {
//   //         dispatch(setLots(response.content));
//   //       } else {
//   //         dispatch(setMessageModal({ title: "Something went wrong!", messages: [response.message] }));
//   //       }
//   //     });
//   //   }
//   // }, [summary.auction]);
//   const handleLinkClick = (event: any) => {
//     event.preventDefault();
//     window.open(summary.auction.documents[0].uploaded_file_url, "_blank");
//   };
//   const shareText = `${summary?.auction?.title}
//   Location: ${summary?.auction?.location?.full_address}
//   Date: ${Utilities.formatDateTime(summary?.auction?.date_from, "Do MMM YYYY, h:mm A")} - ${Utilities.formatDateTime(
//     summary?.auction?.date_to,
//     "Do MMM YYYY, h:mm A",
//   )}
//   Description: ${summary?.auction?.description}
//   Link: ${window.location.href}`;
//   // Convert all images to a newline-separated string
//   const imageLinks = summary?.auction?.images?.map((img: any) => `🖼️ ${img.uploaded_file_url}`).join("\n");
//   // Combine details and images for sharing
//   const fullShareText = `${shareText}\n\n${imageLinks}`;
//   // Share handlers for each platform
//   const handleWhatsAppShare = () => window.open(`https://wa.me/?text=${encodeURIComponent(fullShareText)}`, "_blank");
//   const handleTwitterShare = () => window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(fullShareText)}`, "_blank");
//   const handleTelegramShare = () => window.open(`https://t.me/share/url?text=${encodeURIComponent(fullShareText)}`, "_blank");
//   const handleEmailShare = () => window.open(`mailto:?subject=${encodeURIComponent(summary.auction?.title)}&body=${encodeURIComponent(fullShareText)}`);
//   const handleSmsShare = () => window.open(`sms:?body=${encodeURIComponent(fullShareText)}`);
//   const handleMapShare = () =>
//     window.open(`https://maps.google.com?q=${summary?.auction?.location.latitude},${summary?.auction?.location.longitude}`, "_blank");
//   const handleCallShare = () => window.open(`tel:${summary?.auction?.contact_details?.phone?.number}`);
//   return (
//     <div className="">
//       <ContainerControl className="" loading={isLoading}>
//         {location.key && (
//           <div className="flex pb-4">
//             <ButtonControl
//               label="Back"
//               backgroundColor="bg-primary"
//               startIcon={faArrowLeft}
//               onClick={() => {
//                 navigate(-1);
//               }}
//             />
//           </div>
//         )}
//         <div className="grid grid-row-1 lg:grid-row-2 gap-4 ">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//             <div className="relative">
//               {summary.auction?.youtube_url && (
//                 <div
//                   className="absolute top-10 right-10 text-5xl text-red-500 cursor-pointer z-10"
//                   onClick={() => {
//                     dispatch(
//                       setContentModal({
//                         backdropClose: true,
//                         backgroundColor: "bg-primary",
//                         content: (
//                           <div>
//                             <YouTubePlayer url={summary.auction.youtube_url} controls={true} />
//                           </div>
//                         ),
//                       }),
//                     );
//                   }}
//                 >
//                   <div className="relative flex justify-center items-center">
//                     <FontAwesomeIcon icon={faYoutube} className="z-10 drop-shadow-lg" />
//                     <div className="absolute w-[25px] h-[25px] rounded-full bg-white"></div>
//                   </div>
//                 </div>
//               )}
//               <ContentCarouselControl
//                 addPadding={true}
//                 infinite
//                 // spaceBektween={15}
//                 heightClasses="h-[20rem] md:[22rem] lg:h-[30rem]"
//                 items={summary.auction?.images?.map((image: any, index: number) => {
//                   return {
//                     content: (
//                       <div
//                         className="h-full w-full"
//                         onClick={() => {
//                           // setSelectedDisplayImage(image);
//                         }}
//                       >
//                         <img src={image.uploaded_file_url} className="h-full w-full object-cover" />
//                       </div>
//                     ),
//                   };
//                 })}
//               />
//             </div>
//             <div className="flex flex-col gap-2">
//               <div className="flex flex-col gap-2">
//                 <div className="flex flex-row justify-between">
//                   <div>
//                     <LabelControl size="large" label={summary.auction?.title} bold textColor="text-black" />
//                     <LabelControl size="xsmall" label={summary.auction?.type} bold textColor="text-black" />
//                   </div>
//                   <AuctionStatusTag auctionStatus={summary.auction?.status} />
//                 </div>
//                 <LabelControl size="large" label={summary.auction?.description} textColor="text-black" />
//                 <DividerControl />
//                 <div className="flex gap-2 items-center">
//                   <span className="text-lg text-black">
//                     <FontAwesomeIcon icon={faCircleLocationArrow} />
//                   </span>
//                   <div
//                     className="cursor-pointer"
//                     onClick={() => {
//                       window.open(`https://maps.google.com?q=${summary.auction.location.latitude},${summary.auction.location.longitude}`, "_blank");
//                     }}
//                   >
//                     <LabelControl size="medium" label={summary.auction?.location?.full_address} textColor="text-black" />
//                   </div>
//                 </div>
//                 <div className="flex gap-2 items-center">
//                   <span className="text-lg text-black">
//                     <FontAwesomeIcon icon={faCircleCalendar} />
//                   </span>
//                   <LabelControl
//                     size="medium"
//                     label={`This auction ended on ${Utilities.formatDateTime(
//                       summary.auction?.date_from, //
//                       "Do MMM YYYY, h:mm A",
//                     )}`}
//                     textColor="text-black"
//                     bold
//                   />
//                 </div>
//                 {summary.auction?.registration_fee != null && summary.auction?.registration_fee > 0 && (
//                   <div className="flex gap-2 items-center">
//                     <span className="text-lg text-black">
//                       <FontAwesomeIcon icon={faMoneyBill} />
//                     </span>
//                     <LabelControl
//                       size="medium"
//                       label={`Registration fee: ${Utilities.formatMoney({
//                         value: summary.auction?.registration_fee,
//                         decimalPlaces: 2,
//                       })}`}
//                       textColor="text-black"
//                     />
//                   </div>
//                 )}
//                 <PillsControl
//                   size="medium"
//                   pillSpacing="justify-left"
//                   pills={[
//                     {
//                       visible: !!summary.auction?.contact_details?.whatsapp?.number,
//                       label: `${summary.auction?.contact_details?.whatsapp?.number}`,
//                       icon: faWhatsapp,
//                       colors: {
//                         iconColor: "text-green-500",
//                       },
//                     },
//                     {
//                       visible: !!summary.auction?.contact_details?.phone?.number,
//                       label: `${summary.auction?.contact_details?.phone?.number}`,
//                       icon: faPhone,
//                       colors: {
//                         iconColor: "text-blue-500",
//                       },
//                     },
//                     {
//                       visible: !!summary.auction?.contact_details?.email,
//                       label: `${summary.auction?.contact_details?.email}`,
//                       icon: faEnvelope,
//                       colors: {
//                         iconColor: "text-green-500",
//                       },
//                     },
//                   ]}
//                   colors={{
//                     pills: {
//                       shadowColor: "shadow-gray-200",
//                       backgroundColor: "bg-gray-100",
//                     },
//                   }}
//                 />
//                 <DividerControl orientation="horizontal" />
//                 {/* Share details/contact details */}
//                 <div>
//                   <span className="text-xl font-bold">Contact Details:</span>
//                   <div className="flex gap-2">
//                     <span className="cursor-pointer" onClick={handleWhatsAppShare}>
//                       {whatsappIcon}
//                     </span>
//                     {/* <span className="cursor-pointer" onClick={handleTelegramShare}>
//                   {telegramIcon}
//                 </span> */}
//                     <span className="cursor-pointer" onClick={handleEmailShare}>
//                       {mailIcon}
//                     </span>
//                     <span className="cursor-pointer" onClick={handleSmsShare}>
//                       {msgIcon}
//                     </span>
//                     <span className="cursor-pointer" onClick={handleMapShare}>
//                       {mapIcon}
//                     </span>
//                     <span className="cursor-pointer" onClick={handleCallShare}>
//                       {callingIcon}
//                     </span>
//                     <span className="cursor-pointer" onClick={handleTwitterShare}>
//                       {twitterIcon}
//                     </span>
//                   </div>
//                 </div>
//                 <LabelControl size="large" label={"Documents:"} textColor="text-black" bold />
//                 <div className="flex flex-row flex-wrap gap-4">
//                   {summary.auction?.documents?.length > 0 ? (
//                     summary.auction?.documents?.map((document: any, index: any) => {
//                       return (
//                         <div key={`document-${index}`}>
//                           <a href={document.uploaded_file_url} target="_blank" className="cursor-pointer hover:underline">
//                             <div className="flex gap-2 items-center py-2 px-4 bg-[#EF4444] text-white w-fit rounded-lg">
//                               {pdficon}
//                               {/* <FontAwesomeIcon icon={faFilePdf} size="lg" /> */}
//                               {document.uploaded_file_url.split("/").pop()}
//                             </div>
//                           </a>
//                         </div>
//                       );
//                     })
//                   ) : (
//                     <div className="">
//                       <LabelControl size="medium" label={"No documents found."} textColor="text-black" bold />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="flex flex-col gap-4">
//             <LabelControl size="3xlarge" label={"Lots"} textColor="text-black" bold />
//             <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4">
//               {!isLoading && summary?.lots && summary?.lots?.length > 0 ? (
//                 summary?.lots?.map((l: any, index: number) => {
//                   const lot = l.lot;  
//                   const summary = l.summary;
//                   return (
//                     <div
//                       key={`auction-${index}`}
//                       className="flex flex-col bg-white rounded-lg shadow-lg hover:scale-105 transition-all cursor-pointer"
//                       onClick={() => {
//                         dispatch(setLotSummary(l));
//                         navigate(`${LOT_COMPLETE_DETAILS_ROUTE}/${lot?.entity_id}`);
//                       }}
//                     >
//                       <div className="h-40 aspect-video rounded-lg overflow-clip flex-none relative">
//                         {/* Main image */}
//                         <img src={lot?.images ? lot?.images[0]?.uploaded_file_url : ""} className="object-cover w-full h-full" alt="Lot Image" />
//                         {/* SOLD overlay image */}
//                         {lot?.status && <img src={soldImage} className="absolute top-2  w-16 h-16" alt="Sold" />}  
//                       </div>
//                       <div className="px-4 pt-2 flex justify-between items-center">
//                         <LabelControl label={`#${lot?.lot_number}`} bold size="large" textColor="text-black" />
//                         <LotStatusTag auctionStatus={summary?.auction?.status} lotStatus={lot?.status} size="small" />
//                       </div>
//                       <div className="p-4 flex-1">
//                         <LabelControl label={lot?.title} size="large" textColor="text-black" />
//                       </div>
//                       {lot.status == "Sold" && (
//                         <div className="px-4 pb-4">
//                           <div className="font-bold">
//                             <span className="text-xs">Highest Bid:</span>&nbsp;
//                             <span className=" text-secondary">{Utilities.formatMoney({ value: summary.highest_bid, decimalPlaces: 2 })}</span>
//                           </div>
//                           <div className="font-bold">
//                             <span className="text-xs">Winning Bidder:</span>&nbsp;
//                             <span className="text-secondary">
//                               {summary.bidder?.entity_id == FLOOR_ENTITY_ID ? "Floor Bid" : `#${summary.bidder?.paddle_number}`}
//                             </span>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })
//               ) : (
//                 <LabelControl size="large" label={"No lots have been added to this auction as of yet. Please come back another time."} textColor="text-black" />
//               )}
//             </div>
//           </div>
//         </div>
//       </ContainerControl>
//     </div>
//   );
// };
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var main_1 = require("../../../reducers/slices/main");
var container_1 = require("../../../controls/container");
var react_router_dom_1 = require("react-router-dom");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var free_brands_svg_icons_1 = require("@fortawesome/free-brands-svg-icons");
var routes_1 = require("../../../constants/routes");
var pro_duotone_svg_icons_1 = require("@fortawesome/pro-duotone-svg-icons");
var youtube_1 = __importDefault(require("react-player/youtube"));
var auction_summary_1 = require("../../../api/calls/reporting/auction_summary");
var summary_1 = require("../../../reducers/slices/summary");
var lot_status_tag_1 = require("../../../components/tags/lot_status_tag");
var auction_status_tag_1 = require("../../../components/tags/auction_status_tag");
var floor_1 = require("../../../constants/floor");
var icons_1 = require("../../../../../assets/icons");
var soldImage_png_1 = __importDefault(require("../../../../../assets/soldImage.png"));
var AuctionCompletePage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var location = (0, react_router_dom_1.useLocation)();
    var params = (0, react_router_dom_1.useParams)();
    var auctionID = params.auctionID;
    // const { auction } = useSelector<any, IAuctionSliceState>((state: any) => state.auctionState);
    // const { lots } = useSelector<any, ILotSliceState>((state) => state.lotState);
    var summary = (0, react_redux_1.useSelector)(function (state) { return state.summaryState; }).summary;
    var _19 = (0, react_1.useState)(false), isLoading = _19[0], setIsLoading = _19[1];
    // const [summary, setSummary] = useState<any>({});
    // const [lots, setLots] = useState<any[]>([]);
    (0, react_1.useEffect)(function () {
        if (auctionID) {
            setIsLoading(true);
            (0, auction_summary_1.auction_summary)({
                entity_id: auctionID,
            }).then(function (response) {
                setIsLoading(false);
                if (response.success) {
                    console.log("auction_summary response.content", response.content);
                    dispatch((0, summary_1.setSummary)(response.content));
                }
                else {
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                }
            });
        }
    }, [auctionID]);
    // useEffect(() => {
    //   if (summary.auction?.entity_id) {
    //     lots_for_auction({
    //       auction_entity_id: summary.auction.entity_id,
    //     }).then((response) => {
    //       setIsLoading(false);
    //       if (response.success) {
    //         dispatch(setLots(response.content));
    //       } else {
    //         dispatch(setMessageModal({ title: "Something went wrong!", messages: [response.message] }));
    //       }
    //     });
    //   }
    // }, [summary.auction]);
    var handleLinkClick = function (event) {
        event.preventDefault();
        window.open(summary.auction.documents[0].uploaded_file_url, "_blank");
    };
    var shareText = "".concat((_a = summary === null || summary === void 0 ? void 0 : summary.auction) === null || _a === void 0 ? void 0 : _a.title, "\n  Location: ").concat((_c = (_b = summary === null || summary === void 0 ? void 0 : summary.auction) === null || _b === void 0 ? void 0 : _b.location) === null || _c === void 0 ? void 0 : _c.full_address, "\n  Date: ").concat(doshx_controls_web_1.Utilities.formatDateTime((_d = summary === null || summary === void 0 ? void 0 : summary.auction) === null || _d === void 0 ? void 0 : _d.date_from, "Do MMM YYYY, h:mm A"), " - ").concat(doshx_controls_web_1.Utilities.formatDateTime((_e = summary === null || summary === void 0 ? void 0 : summary.auction) === null || _e === void 0 ? void 0 : _e.date_to, "Do MMM YYYY, h:mm A"), "\n  Description: ").concat((_f = summary === null || summary === void 0 ? void 0 : summary.auction) === null || _f === void 0 ? void 0 : _f.description, "\n  Link: ").concat(window.location.href);
    // Convert all images to a newline-separated string
    var imageLinks = (_h = (_g = summary === null || summary === void 0 ? void 0 : summary.auction) === null || _g === void 0 ? void 0 : _g.images) === null || _h === void 0 ? void 0 : _h.map(function (img) { return "\uD83D\uDDBC\uFE0F ".concat(img.uploaded_file_url); }).join("\n");
    // Combine details and images for sharing
    var fullShareText = "".concat(shareText, "\n\n").concat(imageLinks);
    // Share handlers for each platform
    var handleWhatsAppShare = function () { return window.open("https://wa.me/?text=".concat(encodeURIComponent(fullShareText)), "_blank"); };
    var handleTwitterShare = function () { return window.open("https://twitter.com/intent/tweet?text=".concat(encodeURIComponent(fullShareText)), "_blank"); };
    var handleEmailShare = function () { var _a; return window.open("mailto:?subject=".concat(encodeURIComponent((_a = summary.auction) === null || _a === void 0 ? void 0 : _a.title), "&body=").concat(encodeURIComponent(fullShareText))); };
    var handleSmsShare = function () { return window.open("sms:?body=".concat(encodeURIComponent(fullShareText))); };
    var handleMapShare = function () { var _a, _b; return window.open("https://maps.google.com?q=".concat((_a = summary === null || summary === void 0 ? void 0 : summary.auction) === null || _a === void 0 ? void 0 : _a.location.latitude, ",").concat((_b = summary === null || summary === void 0 ? void 0 : summary.auction) === null || _b === void 0 ? void 0 : _b.location.longitude), "_blank"); };
    var handleCallShare = function () { var _a, _b, _c; return window.open("tel:".concat((_c = (_b = (_a = summary === null || summary === void 0 ? void 0 : summary.auction) === null || _a === void 0 ? void 0 : _a.contact_details) === null || _b === void 0 ? void 0 : _b.phone) === null || _c === void 0 ? void 0 : _c.number)); };
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(container_1.ContainerControl, { className: "", loading: isLoading },
            location.key && (react_1.default.createElement("div", { className: "flex pb-4" },
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Back", backgroundColor: "bg-[#27324E]", startIcon: pro_solid_svg_icons_1.faArrowLeft, onClick: function () {
                        navigate(-1);
                    } }))),
            react_1.default.createElement("div", { className: "grid grid-row-1 lg:grid-row-2 gap-4 " },
                react_1.default.createElement("div", { className: "grid grid-cols-1 lg:grid-cols-2 gap-4" },
                    react_1.default.createElement("div", { className: "relative" },
                        ((_j = summary.auction) === null || _j === void 0 ? void 0 : _j.youtube_url) && (react_1.default.createElement("div", { className: "absolute top-10 right-10 text-5xl text-red-500 cursor-pointer z-10", onClick: function () {
                                dispatch((0, main_1.setContentModal)({
                                    backdropClose: true,
                                    backgroundColor: "bg-primary",
                                    content: (react_1.default.createElement("div", null,
                                        react_1.default.createElement(youtube_1.default, { url: summary.auction.youtube_url, controls: true }))),
                                }));
                            } },
                            react_1.default.createElement("div", { className: "relative flex justify-center items-center" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_brands_svg_icons_1.faYoutube, className: "z-10 drop-shadow-lg" }),
                                react_1.default.createElement("div", { className: "absolute w-[25px] h-[25px] rounded-full bg-white" })))),
                        react_1.default.createElement(doshx_controls_web_1.ContentCarouselControl, { addPadding: true, infinite: true, 
                            // spaceBektween={15}
                            heightClasses: "h-[20rem] md:[22rem] lg:h-[30rem]", items: (_l = (_k = summary.auction) === null || _k === void 0 ? void 0 : _k.images) === null || _l === void 0 ? void 0 : _l.map(function (image, index) {
                                return {
                                    content: (react_1.default.createElement("div", { className: "h-full w-full", onClick: function () {
                                            // setSelectedDisplayImage(image);
                                        } },
                                        react_1.default.createElement("img", { src: image.uploaded_file_url, className: "h-full w-full object-cover" }))),
                                };
                            }) })),
                    react_1.default.createElement("div", { className: "flex flex-col gap-2" },
                        react_1.default.createElement("div", { className: "flex flex-col gap-2" },
                            react_1.default.createElement("div", { className: "flex flex-row justify-between" },
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "large", label: (_m = summary.auction) === null || _m === void 0 ? void 0 : _m.title, bold: true, textColor: "text-black" }),
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "xsmall", label: (_o = summary.auction) === null || _o === void 0 ? void 0 : _o.type, bold: true, textColor: "text-black" })),
                                react_1.default.createElement(auction_status_tag_1.AuctionStatusTag, { auctionStatus: (_p = summary.auction) === null || _p === void 0 ? void 0 : _p.status })),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "large", label: (_q = summary.auction) === null || _q === void 0 ? void 0 : _q.description, textColor: "text-black" }),
                            react_1.default.createElement(doshx_controls_web_1.DividerControl, null),
                            react_1.default.createElement("div", { className: "flex gap-2 items-center" },
                                react_1.default.createElement("span", { className: "text-lg text-black" },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_duotone_svg_icons_1.faCircleLocationArrow })),
                                react_1.default.createElement("div", { className: "cursor-pointer", onClick: function () {
                                        window.open("https://maps.google.com?q=".concat(summary.auction.location.latitude, ",").concat(summary.auction.location.longitude), "_blank");
                                    } },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "medium", label: (_s = (_r = summary.auction) === null || _r === void 0 ? void 0 : _r.location) === null || _s === void 0 ? void 0 : _s.full_address, textColor: "text-black" }))),
                            react_1.default.createElement("div", { className: "flex gap-2 items-center" },
                                react_1.default.createElement("span", { className: "text-lg text-black" },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_duotone_svg_icons_1.faCircleCalendar })),
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "medium", label: "This auction ended on ".concat(doshx_controls_web_1.Utilities.formatDateTime((_t = summary.auction) === null || _t === void 0 ? void 0 : _t.date_from, //
                                    "Do MMM YYYY, h:mm A")), textColor: "text-black", bold: true })),
                            ((_u = summary.auction) === null || _u === void 0 ? void 0 : _u.registration_fee) != null && ((_v = summary.auction) === null || _v === void 0 ? void 0 : _v.registration_fee) > 0 && (react_1.default.createElement("div", { className: "flex gap-2 items-center" },
                                react_1.default.createElement("span", { className: "text-lg text-black" },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_duotone_svg_icons_1.faMoneyBill })),
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "medium", label: "Registration fee: ".concat(doshx_controls_web_1.Utilities.formatMoney({
                                        value: (_w = summary.auction) === null || _w === void 0 ? void 0 : _w.registration_fee,
                                        decimalPlaces: 2,
                                    })), textColor: "text-black" }))),
                            react_1.default.createElement("div", { className: "flex gap-2" },
                                react_1.default.createElement(doshx_controls_web_1.PillsControl, { size: "medium", pillSpacing: "justify-left", pills: [
                                        {
                                            visible: !!((_z = (_y = (_x = summary.auction) === null || _x === void 0 ? void 0 : _x.contact_details) === null || _y === void 0 ? void 0 : _y.whatsapp) === null || _z === void 0 ? void 0 : _z.number),
                                            label: "".concat((_2 = (_1 = (_0 = summary.auction) === null || _0 === void 0 ? void 0 : _0.contact_details) === null || _1 === void 0 ? void 0 : _1.whatsapp) === null || _2 === void 0 ? void 0 : _2.number),
                                            icon: free_brands_svg_icons_1.faWhatsapp,
                                            colors: {
                                                iconColor: "text-white",
                                                textColor: "text-white",
                                            },
                                        },
                                    ], colors: {
                                        pills: {
                                            backgroundColor: "bg-[#4CAF50]",
                                            shadowColor: "shadow-gray-200",
                                            textColor: "text-white",
                                        },
                                    } }),
                                react_1.default.createElement(doshx_controls_web_1.PillsControl, { size: "medium", pillSpacing: "justify-left", pills: [
                                        {
                                            visible: !!((_5 = (_4 = (_3 = summary.auction) === null || _3 === void 0 ? void 0 : _3.contact_details) === null || _4 === void 0 ? void 0 : _4.phone) === null || _5 === void 0 ? void 0 : _5.number),
                                            label: "".concat((_8 = (_7 = (_6 = summary.auction) === null || _6 === void 0 ? void 0 : _6.contact_details) === null || _7 === void 0 ? void 0 : _7.phone) === null || _8 === void 0 ? void 0 : _8.number),
                                            icon: pro_solid_svg_icons_1.faPhone,
                                            colors: {
                                                iconColor: "text-white",
                                                textColor: "text-white",
                                            },
                                        },
                                        {
                                            visible: !!((_10 = (_9 = summary.auction) === null || _9 === void 0 ? void 0 : _9.contact_details) === null || _10 === void 0 ? void 0 : _10.email),
                                            label: "".concat((_12 = (_11 = summary.auction) === null || _11 === void 0 ? void 0 : _11.contact_details) === null || _12 === void 0 ? void 0 : _12.email),
                                            icon: pro_solid_svg_icons_1.faEnvelope,
                                            colors: {
                                                iconColor: "text-white",
                                                textColor: "text-white",
                                            },
                                        },
                                    ], colors: {
                                        pills: {
                                            backgroundColor: "bg-blue-500",
                                            shadowColor: "shadow-gray-200",
                                            textColor: "text-white",
                                        },
                                    } })),
                            react_1.default.createElement(doshx_controls_web_1.DividerControl, { orientation: "horizontal" }),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", { className: "text-xl font-bold" }, "Contact Details:"),
                                react_1.default.createElement("div", { className: "flex gap-2" },
                                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleWhatsAppShare }, icons_1.whatsappIcon),
                                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleEmailShare }, icons_1.mailIcon),
                                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleSmsShare }, icons_1.msgIcon),
                                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleMapShare }, icons_1.mapIcon),
                                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleCallShare }, icons_1.callingIcon),
                                    react_1.default.createElement("span", { className: "cursor-pointer", onClick: handleTwitterShare }, icons_1.twitterIcon))),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "large", label: "Documents:", textColor: "text-black", bold: true }),
                            react_1.default.createElement("div", { className: "flex flex-row flex-wrap gap-4" }, ((_14 = (_13 = summary.auction) === null || _13 === void 0 ? void 0 : _13.documents) === null || _14 === void 0 ? void 0 : _14.length) > 0 ? ((_16 = (_15 = summary.auction) === null || _15 === void 0 ? void 0 : _15.documents) === null || _16 === void 0 ? void 0 : _16.map(function (document, index) {
                                return (react_1.default.createElement("div", { key: "document-".concat(index) },
                                    react_1.default.createElement("a", { href: document.uploaded_file_url, target: "_blank", className: "cursor-pointer hover:underline" },
                                        react_1.default.createElement("div", { className: "flex gap-2 items-center py-2 px-4 bg-[#EF4444] text-white w-fit rounded-lg" },
                                            icons_1.pdficon,
                                            document.uploaded_file_url.split("/").pop()))));
                            })) : (react_1.default.createElement("div", { className: "" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "medium", label: "No documents found.", textColor: "text-black", bold: true }))))))),
                react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "3xlarge", label: "Lots", textColor: "text-black", bold: true }),
                    react_1.default.createElement("div", { className: "grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4" }, !isLoading && (summary === null || summary === void 0 ? void 0 : summary.lots) && ((_17 = summary === null || summary === void 0 ? void 0 : summary.lots) === null || _17 === void 0 ? void 0 : _17.length) > 0 ? ((_18 = summary === null || summary === void 0 ? void 0 : summary.lots) === null || _18 === void 0 ? void 0 : _18.map(function (l, index) {
                        var _a, _b, _c, _d;
                        var lot = l.lot;
                        var summary = l.summary;
                        return (react_1.default.createElement("div", { key: "auction-".concat(index), className: "flex flex-col bg-white rounded-lg shadow-lg hover:scale-105 transition-all cursor-pointer", onClick: function () {
                                dispatch((0, summary_1.setLotSummary)(l));
                                navigate("".concat(routes_1.LOT_COMPLETE_DETAILS_ROUTE, "/").concat(lot.entity_id));
                            } },
                            react_1.default.createElement("div", { className: "h-40 aspect-video rounded-lg overflow-clip flex-none relative" },
                                react_1.default.createElement("img", { src: lot.images ? (_a = lot.images[0]) === null || _a === void 0 ? void 0 : _a.uploaded_file_url : "", className: "object-cover w-full h-full" }),
                                (lot === null || lot === void 0 ? void 0 : lot.status) && react_1.default.createElement("img", { src: soldImage_png_1.default, className: "absolute top-2  w-16 h-16", alt: "Sold" })),
                            react_1.default.createElement("div", { className: "px-4 pt-2 flex justify-between items-center" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "#".concat(lot.lot_number), bold: true, size: "large", textColor: "text-black" }),
                                react_1.default.createElement(lot_status_tag_1.LotStatusTag, { auctionStatus: (_b = summary === null || summary === void 0 ? void 0 : summary.auction) === null || _b === void 0 ? void 0 : _b.status, lotStatus: lot.status, size: "small" })),
                            react_1.default.createElement("div", { className: "p-4 flex-1" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: lot.title, size: "large", textColor: "text-black" })),
                            lot.status == "Sold" && (react_1.default.createElement("div", { className: "px-4 pb-4" },
                                react_1.default.createElement("div", { className: "font-bold" },
                                    react_1.default.createElement("span", { className: "text-xs" }, "Highest Bid:"),
                                    "\u00A0",
                                    react_1.default.createElement("span", { className: " text-secondary" }, doshx_controls_web_1.Utilities.formatMoney({ value: summary.highest_bid, decimalPlaces: 2 }))),
                                react_1.default.createElement("div", { className: "font-bold" },
                                    react_1.default.createElement("span", { className: "text-xs" }, "Winning Bidder:"),
                                    "\u00A0",
                                    react_1.default.createElement("span", { className: "text-secondary" }, ((_c = summary.bidder) === null || _c === void 0 ? void 0 : _c.entity_id) == floor_1.FLOOR_ENTITY_ID ? "Floor Bid" : "#".concat((_d = summary.bidder) === null || _d === void 0 ? void 0 : _d.paddle_number)))))));
                    })) : (react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "large", label: "No lots have been added to this auction as of yet. Please come back another time.", textColor: "text-black" }))))))));
};
exports.AuctionCompletePage = AuctionCompletePage;
